export default {
    watch: {
        page_title: function (val) {
            this.setMainTitle()
        }
    },
    computed: {

    },
    methods: {
        setPageTitleWithObject(type, {uid, id}, separator=' ', short=null, finalizer=()=>{}){
          /**
           * Добавляет значение к заголовку страницы
           * @param {string} type - Тип значения (user, project и т.д.)
           * @param {Object} ids - Идентификаторы {uid, id}
           * @param {string} separator - Разделитель (по умолчанию ' ')
           * @param {boolean} short - Краткая версия значения
           * @param {Function} callback - Коллбек после обновления
           */
            this.$store.dispatch(
                "stringvalue/loadStringValue",
                {
                    type: type,
                    uid: uid,
                    id: id,
                    short: short,
                    finalizer: (value) => {
                        this.page_title += `${separator}${value}`
                        finalizer(value)
                    }
                })
        },
        setMainTitle(){
          /**
           * Устанавливает значение главной страницы
           */
            this.$store.commit('mainpage/changeTitle', this.page_title);
        }
    },
    created() {
        this.setMainTitle();
    }

}
